// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productListFilterAccordionSectionStyles } from "@awc/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import IconSearch from "@awc/XDL/Icons/Search";
import { createLinkIconStyles, styledScrollbar } from "@awc/XDL/Utilities";
import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        width: 100%;
    `,
    typographyProps: {
        css: css`
            word-break: break-all;
            display: flex;
            width: 100%;
        `,
    },
};

productListFilterAccordionSectionStyles.facetCount = {
    color: "common.ui6",
    css: css`
        margin-left: 4px;
    `,
};

productListFilterAccordionSectionStyles.seeAllLink = {
    ...createLinkIconStyles({ sizeVariant: "medium" }),
};

productListFilterAccordionSectionStyles.seeLessLink = {
    ...createLinkIconStyles({ sizeVariant: "medium" }),
};

productListFilterAccordionSectionStyles.facetFilterTextField = {
    iconProps: {
        src: IconSearch,
        color: "secondary",
    },
    sizeVariant: "small",
    css: css`
        + ${IconWrapper} {
            right: 2px;
            width: auto;
            svg {
                height: auto;
                width: 12px;
            }
        }
    `,
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        width: 100%;
        &:not(:last-child) {
            padding-bottom: 12px;
        }
    `,
};

productListFilterAccordionSectionStyles.scrollableContainer = {
    css: css`
        ${({ filterable }: any) =>
            filterable &&
            css`
                margin-top: 12px;
            `}
        ${({ scrollable, limitNumber }: any) =>
            scrollable &&
            css`
                max-height: calc(${limitNumber * 26 + 18}px);
                padding-right: 8px;
                ${styledScrollbar()};
            `}
    `,
};

productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            overflow-x: hidden;
        `,
    },
};
